import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, } from 'primeng/api';
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ValidatorUtils } from '../core/_util/validator-util';

@Component({
  selector: 'app-dias-servicio',
  templateUrl: './dias-servicio.component.html',
  styleUrls: ['./dias-servicio.component.scss']
})
export class DiasServicioComponent extends ValidatorUtils implements OnInit {

  @Input() fichaActual: any;
  cargandoTabla: boolean = false;

  //formulario
  formBuilder: FormBuilder;
  formulario: FormGroup;
  mostrarFormulario: Boolean = false;
  registroNuevo: Boolean = false;
  submitted: Boolean = false;

  //lista de registros
  registrosLista: any;
  columnas: any[];
  totalRecords = 0;
  listaServicios: any[];
  listadoServicios: any[];

  espanol: any;

  diasAdicionales: any[];

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    public confirmationService: ConfirmationService
  ) {
    super();
    this.formBuilder = new FormBuilder();
    this.formulario = this.formBuilder.group({
      tipoServicio: ['', Validators.required],
      numeroDia: ['', Validators.required],
    });
    this.diasAdicionales = [
      { name: '1', code: '1' },
      { name: '2', code: '2' },
      { name: '3', code: '3' },
      { name: '4', code: '4' },
      { name: '5', code: '5' },
      { name: '6', code: '6' },
      { name: '7', code: '7' },
      { name: '8', code: '8' },
      { name: '9', code: '9' },
      { name: '10', code: '10' }

    ];
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'id_servicio', subfield: 'nom_servicio', header: 'Servicio Adicional' },
      { field: 'dias_adic', header: 'Dias Adicionales' },
    ];

    this.totalRecords = 0;
    this.listar();
    this.getlistatiposervicio();
  }

  nuevo() {
    this.formulario.reset();
    this.mostrarFormulario = true;
    this.registroNuevo = true;
  }

  editar(data) {
    this.registroNuevo = false;
    this.mostrarFormulario = true;
  }

  volver() {
    this.mostrarFormulario = false;
    this.submitted = false;
  }

  guardar() {
    var dat = this.formulario.valid;
    this.formulario.markAllAsTouched();
    if (dat) {
      this.confirmationService.confirm({
        message: '¿Desea guardar este registro?',
        accept: () => {
          this.submitted = true;
          this.guardarServicio();
        }
      });
    }
  }

  listar() {
    let data = {
      id_ficha: this.fichaActual
    }
    this.mostrarFormulario = false;
    this.cargandoTabla = true;
    this.coreService.getWithParams('/obtenerServiciosFicha', data).subscribe(
      (res: any[]) => {
        this.listadoServicios = res;
        this.totalRecords = this.listadoServicios.length;
        this.cargandoTabla = false;
      },
      (err: any) => {
        this.cargandoTabla = false;
        console.log(err);
      }
    )

  }
  getlistatiposervicio() {
    this.coreService.get('/obtenerlistaServicios').subscribe(
      (res: any) => {
        this.listaServicios = res.servicio;
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

  guardarServicio() {
    let data = {
      fichaActual: this.fichaActual,
      servicio_id: this.formulario.value.tipoServicio.id,
      dias_id: this.formulario.value.numeroDia.code,
    }
    this.coreService.post('/guardar-servicio-adicional', data).subscribe(
      (res: any[]) => {
        this.msj.info('Registro Guardado.');
        this.listar();
        this.mostrarFormulario = false;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  eliminar(idRegistro) {
    this.confirmationService.confirm({
      message: '¿Desea eliminar el registro con ID:' + idRegistro.id + '?',
      accept: () => {
        this.submitted = true;
        this.eliminarServicio(idRegistro.id);
        this.mostrarFormulario = false;
      }
    });
  }

  eliminarServicio(idRegistro) {
    this.coreService.delete('/eliminar-servicio-adicional', idRegistro).subscribe(
      (res: any[]) => {
        this.msj.info('Registro Eliminado.');
        this.listar();
      },
      (err: any) => {
        if (err.error !== undefined && err.error !== null) {
          for (let index = 0; index < err.error.length; index++) {
            this.msj.error(err.error[index]);
          }
        }
      }
    );
  }

}
